import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RegisterFormPopupComponent } from 'src/app/components/register-form-popup/register-form-popup.component';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss'],
})
export class MasterComponent {
  constructor(public matDialog: MatDialog) {}

  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openRegisterFormPopup() {
    this.matDialog.open(RegisterFormPopupComponent, {
      disableClose: true,
      panelClass: ['custom-modalbox', 'animate__animated', 'animate__fadeInDown'],
      data: {},
    });
  }
}
